import { ReactElement } from 'react';
import { Button } from '@chakra-ui/react';

type ThumbRatingButtonProps = {
  emoji: string;
  ariaLabel: string;
  isSelected: boolean;
  onClick: () => void;
  disabled?: boolean;
};

export const ThumbRatingButton = ({
  emoji,
  ariaLabel,
  isSelected,
  onClick,
  disabled = false,
}: ThumbRatingButtonProps): ReactElement => (
  <Button
    type="button"
    variant="secondaryOutline"
    size="m"
    aria-label={ariaLabel}
    aria-pressed={isSelected}
    onClick={onClick}
    disabled={disabled}
    px="m"
    py="s"
    minW="auto"
    bg={isSelected ? 'background.subtle.green' : 'background.primary'}
    borderColor={isSelected ? 'border.accent.active' : 'border.accent'}
    borderRadius="l"
  >
    {emoji}
  </Button>
);
